<template>
  <v-dialog max-width="80%" v-model="dialogView" scrollable>
    <v-card>
      <v-card-title> Visualizar Orden de Programación de Pago </v-card-title>

      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          size="128"
          width="4"
          class="mb-3"
          color="primary"
        />
        <div class="text-subtitle-2">
          Cargando detalles de la Orden de Programación de Pago ...
        </div>
      </v-card-text>

      <v-card-text v-else class="pt-4">
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <div class="text-subtitle-2"># Orden de Programación de Pago:</div>
            <div>{{ viewItem.clave }}</div>
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <div class="text-subtitle-2">Concepto:</div>
            <div><strong>{{ viewItem.nombre_gasto_tipo }}</strong> - {{ viewItem.nombre_gasto_subtipo }}</div>
          </v-col>

          <v-col cols="12" md="4" class="py-0">
            <div class="text-subtitle-2">Monto Total (sin impuestos):</div>
            <div>{{ getMonedaSimbolo(viewItem.id_moneda) }}{{ formatMoney(viewItem.monto) }}</div>
          </v-col>

          <v-col cols="12" md="2" class="py-0">
            <div class="text-subtitle-2">Moneda:</div>
            <div>{{ getMonedaClave(viewItem.id_moneda) }}</div>
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <div class="text-subtitle-2">Número de Facturas Esperadas:</div>
            <div>
              {{ viewItem.numero_facturas }}
              {{ viewItem.numero_facturas === 1 ? "factura" : "facturas" }}
            </div>
          </v-col>

          <v-col cols="12" class="py-0 mt-1">
            <div class="text-subtitle-2">Descripción:</div>
            <div>{{ viewItem.descripcion || "Sin descripción" }}</div>
          </v-col>

          <v-col cols="12" class="py-0 mt-1">
            <div class="text-subtitle-2">Archivo de Cotización/Presupuesto:</div>
            <div>
              <template v-if="viewItem.archivo_cotizacion">
                <v-viewer
                  v-model="viewItem.archivo_cotizacion"
                  label="Archivo de Cotización/Presupuesto"
                  url-base="/api/Pagos/DescargarProgramacionCompraOrdenDocumento"
                />
              </template>
              <template v-else>
                Sin archivo adjunto
              </template>
            </div>
          </v-col>

          <v-col cols="12" md="6" class="py-0 mt-1" v-if="viewItem.numero_facturas > 1">
            <div class="text-subtitle-2">Intervalo de Facturación:</div>
            <div>{{ viewItem.nombre_intervalo }}</div>
          </v-col>

          <v-col cols="12" md="6" class="py-0 mt-1" v-if="viewItem.numero_facturas > 1">
            <div class="text-subtitle-2">Fecha de Inicio:</div>
            <div>{{ viewItem.fecha_inicio }}</div>
          </v-col>


          <!-- PROVEEDOR -->
          <v-col cols="12" class="pa-0 ma-0 text-center mb-2">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon class="mr-1">mdi-truck</v-icon>
              Proveedor
            </div>
          </v-col>

          <v-col cols="12">
            <v-row dense class="ma-0">
              <v-col cols="3" class="py-0">
                <div class="text-subtitle-2">Clave:</div>
                <div>{{ viewItem.codigo_proveedor }}</div>
              </v-col>

              <v-col cols="3" class="py-0">
                <div class="text-subtitle-2">Tipo de Proveedor:</div>
                <div>{{ viewItem.tipo_proveedor }}</div>
              </v-col>

              <v-col cols="3" class="py-0">
                <div class="text-subtitle-2">Tipo de Persona:</div>
                <div>{{ viewItem.persona_tipo }}</div>
              </v-col>

              <v-col cols="3" class="py-0">
                <div class="text-subtitle-2">Nombre Comercial:</div>
                <div>{{ viewItem.nombre_proveedor }}</div>
              </v-col>
            </v-row>
          </v-col>

          <!-- PROGRAMACIÓN DE FACTURAS -->
          <v-col
            cols="12"
            v-if="
              viewItem.numero_facturas > 0 &&
              viewItem.facturas &&
              viewItem.facturas.length > 0
            "
            class="mt-4"
          >
            <div class="text-center mb-2">
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-1">mdi-calendar-clock</v-icon>
                Programación de Facturas
              </div>
            </div>

            <v-card class="pa-2" elevation="0">
              <v-data-table
                :headers="headersFacturasView"
                :items="viewItem.facturas"
                dense
                hide-default-footer
                :items-per-page="-1"
                class="elevation-0"
              >
                <!-- N° -->
                <template v-slot:[`item.no`]="{ index }">
                  <div class="text-center">{{ index + 1 }}</div>
                </template>

                <!-- Fecha (chips permitidos aquí) -->
                <template v-slot:[`item.fecha`]="{ item }">
                  <div class="text-center">
                    <v-chip small outlined>
                      <v-icon left x-small>mdi-calendar</v-icon>
                      {{ item.fecha }}
                    </v-chip>
                  </div>
                </template>

                <!-- Estado factura (chips permitidos aquí) -->
                <template v-slot:[`item.id_estado_factura`]="{ item }">
                  <div class="text-center">
                    <template
                      v-if="
                        item.id_estado_factura === ESTADO_FACTURA.ACEPTADA ||
                        item.id_estado_factura === ESTADO_FACTURA.RECHAZADA
                      "
                    >
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            small
                            outlined
                            :color="getColorEstadoFactura(item.id_estado_factura)"
                          >
                            <v-icon left x-small>
                              {{ getIconEstadoFactura(item.id_estado_factura) }}
                            </v-icon>
                            {{ getNombreEstadoFactura(item.id_estado_factura) }}
                            <v-icon right x-small>mdi-information-outline</v-icon>
                          </v-chip>
                        </template>

                        <div class="text-caption">
                          <div>
                            <strong>Por:</strong>
                            {{ item.usuario_estado_factura || "N/A" }}
                          </div>
                          <div class="mt-1">
                            <strong>Fecha:</strong>
                            {{ item.fecha_estado_factura || "N/A" }}
                          </div>
                          <div class="mt-1" v-if="item.id_estado_factura === ESTADO_FACTURA.RECHAZADA">
                            <strong>Motivo Rechazo:</strong>
                            {{ item.motivo_rechazo_factura || "N/A" }}
                          </div>
                        </div>
                      </v-tooltip>
                    </template>

                    <template v-else>
                      <v-chip
                        small
                        outlined
                        :color="getColorEstadoFactura(item.id_estado_factura)"
                      >
                        <v-icon left x-small>
                          {{ getIconEstadoFactura(item.id_estado_factura) }}
                        </v-icon>
                        {{ getNombreEstadoFactura(item.id_estado_factura) }}
                      </v-chip>
                    </template>
                  </div>
                </template>

                <!-- Estado pago (chips permitidos aquí) -->
                <template v-slot:[`item.id_estado_pago`]="{ item }">
                  <div class="text-center">
                    <template v-if="item.id_estado_factura === ESTADO_FACTURA.ACEPTADA && item.id_estado_pago !== ESTADO_PAGO.PENDIENTE">
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            small
                            outlined
                            :color="getColorEstadoPago(item.id_estado_pago)"
                          >
                            <v-icon left x-small>
                              {{ getIconEstadoPago(item.id_estado_pago) }}
                            </v-icon>
                            {{ getNombreEstadoPago(item.id_estado_pago) }}
                            <v-icon right x-small>mdi-information-outline</v-icon>
                          </v-chip>
                        </template>

                        <div class="text-caption">
                          <div>
                            <strong>Por:</strong>
                            {{ item.usuario_estado_pago || "N/A" }}
                          </div>
                          <div class="mt-1">
                            <strong>Fecha:</strong>
                            {{ item.fecha_estado_pago || "N/A" }}
                          </div>
                        </div>
                      </v-tooltip>
                    </template>

                    <template v-else>
                      —
                    </template>
                  </div>
                </template>

                <template v-slot:[`item.monto`]="{ item }">
                  <div class="text-center">
                    {{ getMonedaSimbolo(viewItem.id_moneda) }}{{ formatMoney(item.monto) }}
                    {{ getMonedaClave(viewItem.id_moneda) }}
                  </div>
                </template>

                <template v-slot:[`item.iva`]="{ item }">
                  {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getIva(item.monto)) }} {{ getMonedaClave(viewItem.id_moneda) }}
                </template>

                <template v-slot:[`item.isr`]="{ item }">
                  {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getIsr(item.monto)) }} {{ getMonedaClave(viewItem.id_moneda) }}
                </template>

                <template v-slot:[`item.iva_retencion`]="{ item }">
                  {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getIvaRetencion(item.monto)) }} {{ getMonedaClave(viewItem.id_moneda) }}
                </template>

                <template v-slot:[`item.total`]="{ item }">
                  {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getTotal(item.monto)) }} {{ getMonedaClave(viewItem.id_moneda) }}
                </template>

                <template v-slot:[`item.total_pagado`]="{ item }">
                  {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getTotalSinRetenciones(item.monto)) }} {{ getMonedaClave(viewItem.id_moneda) }}
                </template>

                <!-- Total al final -->
                <template v-slot:[`body.append`]>
                  <tr class="grey lighten-4">
                    <td colspan="7" class="text-right">
                      <strong>Total:</strong>
                    </td>
                    <td class="text-right">
                      <strong>
                        {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getTotal(viewItem.monto)) }}
                        {{ getMonedaClave(viewItem.id_moneda) }}
                      </strong>
                    </td>
                    <td class="text-right">
                      <strong>
                        {{ getMonedaSimbolo(viewItem.id_moneda) }} {{ formatMoney(getTotalSinRetenciones(viewItem.monto)) }}
                        {{ getMonedaClave(viewItem.id_moneda) }}
                      </strong>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0 mb-0 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon>mdi-history</v-icon>
              Información de Auditoría
            </div>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="logsHeaders"
              :items="logs"
              dense
              :items-per-page="10"
              class="elevation-1"
              :loading="loadingLogs"
            >
              <!-- Columna de icono/estado -->
              <template v-slot:[`item.icon`]="{ item }">
                <v-icon small :color="getColorLog(item.mensaje)">
                  {{ getIconLog(item.mensaje) }}
                </v-icon>
              </template>

              <!-- Columna de fecha más compacta -->
              <template v-slot:[`item.fecha`]="{ item }">
                <span class="text-caption grey--text">{{ item.fecha }}</span>
              </template>

              <!-- Columna de usuario con chip -->
              <template v-slot:[`item.usuario`]="{ item }">
                <v-chip
                  x-small
                  label
                  :color="item.usuario.includes('Automatico') ? 'grey lighten-2' : 'blue lighten-4'"
                >
                  {{ item.usuario }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="green" text @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import VViewer from '@/components/VViewer.vue';

export default {
  components: {
    VViewer
  },
  data: () => ({
    loading: false,
    id_programacion_compra_orden: null,

    // =========================
    // "Enums" (ints)
    // =========================
    ESTADO_FACTURA: {
      PENDIENTE: 1,
      EN_REVISION: 2,
      ACEPTADA: 3,
      RECHAZADA: 4
    },
    ESTADO_PAGO: {
      PENDIENTE: 1,
      REALIZADO: 2
    },

    // =========================
    // Catálogos (ints)
    // =========================
    cat_estados_factura: [
      { id_estado_factura: 1, nombre: "Pendiente", color: "info", icon: "mdi-clock-outline" },
      { id_estado_factura: 2, nombre: "En Revisión", color: "warning", icon: "mdi-clipboard-search" },
      { id_estado_factura: 3, nombre: "Aceptada", color: "success", icon: "mdi-check-circle" },
      { id_estado_factura: 4, nombre: "Rechazada", color: "error", icon: "mdi-close-circle" }
    ],
    cat_estados_pago: [
      { id_estado_pago: 1, nombre: "Pendiente", color: "info", icon: "mdi-timer-sand" },
      { id_estado_pago: 2, nombre: "Realizado", color: "success", icon: "mdi-cash-check" }
    ],

    headersFacturasView: [
      { text: "N°", value: "no", align: "center", sortable: false, width: 70 },
      { text: "Fecha habilitada para recepción de factura", value: "fecha", align: "center", sortable: false },
      { text: "Estado factura", value: "id_estado_factura", align: "center", sortable: false },
      /*{ text: "Estado pago", value: "id_estado_pago", align: "center", sortable: false },*/
      { text: "Monto", value: "monto", align: "center", sortable: false },
      {
        text: "IVA",
        value: "iva",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "ISR",
        value: "isr",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "Retención IVA",
        value: "iva_retencion",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "Total Facturado",
        value: "total",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "Total Pagado",
        value: "total_pagado",
        align: "end",
        width: "16%",
        sortable: false
      }
    ],

    viewItem: {
      id_programacion_compra_orden: null,
      clave: null,
      id_gasto_subtipo: null,
      nombre_gasto_subtipo: null,
      nombre_gasto_tipo: null,
      id_moneda: null,
      nombre_moneda: null,
      monto: 0,

      no_serie: null,
      marca: null,
      modelo: null,
      no_inventario_ubga: null,

      id_proyecto: null,
      nombre_proyecto: null,
      ids_empleados: null,

      id_proveedor: null,
      nombre_proveedor: null,
      codigo_proveedor: null,
      tipo_proveedor: null,
      persona_tipo: null,

      descripcion: null,
      id_fiscal_regla: null,

      numero_facturas: 0,
      id_intervalo: null,
      nombre_intervalo: null,

      fecha_inicio: null,
      archivo_cotizacion: null,

      id_usuario_autorizo: null,
      nombre_usuario_autorizo: null,
      fecha_autorizacion: null,

      facturas: []
    },
    defaultViewItem: {
      id_programacion_compra_orden: null,
      clave: null,
      id_gasto_subtipo: null,
      nombre_gasto_subtipo: null,
      nombre_gasto_tipo: null,
      id_moneda: null,
      nombre_moneda: null,
      monto: 0,

      no_serie: null,
      marca: null,
      modelo: null,
      no_inventario_ubga: null,

      id_proyecto: null,
      nombre_proyecto: null,
      ids_empleados: null,

      id_proveedor: null,
      nombre_proveedor: null,
      codigo_proveedor: null,
      tipo_proveedor: null,
      persona_tipo: null,

      descripcion: null,
      id_fiscal_regla: null,

      numero_facturas: 0,
      id_intervalo: null,
      nombre_intervalo: null,

      fecha_inicio: null,
      archivo_cotizacion: null,

      id_usuario_autorizo: null,
      nombre_usuario_autorizo: null,
      fecha_autorizacion: null,

      facturas: []
    },

    dialogView: false,

    monedas: [],
    loadingMonedas: false,

    logs: [],
    loadingLogs: false,

    logsHeaders: [
      { text: '', value: 'icon', width: '50px', sortable: false },
      { text: 'Fecha', value: 'fecha', width: '140px' },
      { text: 'Usuario', value: 'usuario', width: '200px' },
      { text: 'Acción', value: 'mensaje' }
    ],
  }),

  mounted() {
    this.getMonedas();
  },

  computed: {
    sumaFacturasView() {
      if (!this.viewItem.facturas) return 0;
      return this.viewItem.facturas.reduce((sum, factura) => {
        return sum + (parseFloat(factura.monto) || 0);
      }, 0);
    }
  },

  methods: {
    // =========================
    // API del dialog
    // =========================
    open(viewItem) {
      this.dialogView = true;
      this.viewItem = Object.assign({}, viewItem);
      this.getLogs();
    },

    close() {
      this.viewItem = Object.assign({}, this.defaultViewItem);
      this.dialogView = false;
      this.loading = false;
      this.loadingLogs = false;
      this.logs = [];
    },


    // =========================
    // Render helpers - factura
    // =========================
    findEstadoFactura(id) {
      return this.cat_estados_factura.find(x => x.id_estado_factura === id) || null;
    },
    getNombreEstadoFactura(id) {
      const it = this.findEstadoFactura(id);
      return it ? it.nombre : "N/A";
    },
    getColorEstadoFactura(id) {
      const it = this.findEstadoFactura(id);
      return it ? it.color : "grey";
    },
    getIconEstadoFactura(id) {
      const it = this.findEstadoFactura(id);
      return it ? it.icon : "mdi-help-circle";
    },

    // =========================
    // Render helpers - pago
    // =========================
    findEstadoPago(id) {
      return this.cat_estados_pago.find(x => x.id_estado_pago === id) || null;
    },
    getNombreEstadoPago(id) {
      const it = this.findEstadoPago(id);
      return it ? it.nombre : "N/A";
    },
    getColorEstadoPago(id) {
      const it = this.findEstadoPago(id);
      return it ? it.color : "grey";
    },
    getIconEstadoPago(id) {
      const it = this.findEstadoPago(id);
      return it ? it.icon : "mdi-help-circle";
    },

    // =========================
    // Formatos
    // =========================
    formatMoney(value) {
      if (!value) return "0.00";
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },

    getIva(monto){
      return monto * ((this.viewItem.iva || 0) / 100.0);
    },

    getIsr(monto){
      return monto * ((this.viewItem.isr || 0) / 100.0);
    },

    getIvaRetencion(monto){
      return monto * ((this.viewItem.iva_retencion || 0) / 100.0);
    },

    getTotal(monto){
      return (monto) + (this.getIva(monto) || 0.0) - (this.getIsr(monto) || 0.0) - (this.getIvaRetencion(monto) || 0.0);
    },

    getTotalSinRetenciones(monto){
      return (monto) + (this.getIva(monto) || 0.0);
    },

    getMonedaClave(idMoneda) {
      if (!idMoneda) return '';
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.clave : '';
    },

    getMonedaSimbolo(idMoneda) {
      if (!idMoneda) return '';
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.simbolo : '';
    },

    // =========================
    // Monedas (mock)
    // =========================
    getMonedas() {
      this.loadingMonedas = true;
      axios
        .get('/Catalogos/ListarMonedas')
        .then(response => {
          this.monedas = response.data || [];
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "No se pudieron cargar las monedas");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingMonedas = false;
        });
    },

    getLogs(){
      this.loadingLogs = true;

      axios
      .get(`/Pagos/ListarProgramacionCompraOrdenCambios/${this.viewItem.id_programacion_compra_orden}`)
      .then(response => {
        this.logs = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingLogs = false;
      })
    },

    getIconLog(mensaje) {
      if (mensaje.includes('Creó')) return 'mdi-plus-circle'
      if (mensaje.includes('Actualizó')) return 'mdi-pencil-circle'
      if (mensaje.includes('Autorizó')) return 'mdi-check-circle'
      if (mensaje.includes('Canceló')) return 'mdi-close-circle'
      return 'mdi-information'
    },
    getColorLog(mensaje) {
      if (mensaje.includes('Creó')) return 'primary'
      if (mensaje.includes('Actualizó')) return 'blue'
      if (mensaje.includes('Autorizó')) return 'success'
      if (mensaje.includes('Canceló')) return 'error'
      return 'grey'
    }
  }
};
</script>
